import { clsx } from 'clsx';

export const PlaygroundSettingsVersion = ({ settings }) => {
  return (
    <span
      className={clsx(
        'text-tiny font-medium rounded-sm-5 border px-2 py-1 !no-underline',
        settings.is_deployed
          ? 'text-[#389D61] border-[#389d6126] bg-[#F4FFF7]'
          : 'text-ebony_opacity_50 border-grey_border bg-light',
      )}
    >
      Version {settings.version}
    </span>
  );
};
